var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "quote-form", class: { "in-porgress": _vm.isInProgress } },
    [
      !_vm.isInProgress
        ? _c("div", { staticClass: "form-container" }, [
            _c(
              "div",
              { staticClass: "title-header" },
              [
                _c("rt-picture", {
                  staticClass: "icon-request",
                  attrs: {
                    src: "/assets/app/class/icon-infinite-rocket.svg",
                    autosize: false,
                  },
                }),
                _vm._v(" "),
                _vm._m(0),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-wrapper" }, [
              _c(
                "div",
                { staticClass: "input-wrapper" },
                [
                  _c("rt-input", {
                    attrs: {
                      placeholder: "Your name",
                      floatingLabel: "Your name",
                      borderError: _vm.errors.name.error,
                    },
                    model: {
                      value: _vm.form_data.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form_data, "name", $$v)
                      },
                      expression: "form_data.name",
                    },
                  }),
                  _vm._v(" "),
                  _vm.errors.name.error
                    ? _c("p", { staticClass: "input-error" }, [
                        _vm._v(_vm._s(_vm.errors.name.message)),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-wrapper" },
                [
                  _c("rt-input", {
                    attrs: {
                      placeholder: "School/District name",
                      floatingLabel: "School/District name",
                      borderError: _vm.errors.school_name.error,
                    },
                    model: {
                      value: _vm.form_data.school_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form_data, "school_name", $$v)
                      },
                      expression: "form_data.school_name",
                    },
                  }),
                  _vm._v(" "),
                  _vm.errors.school_name.error
                    ? _c("p", { staticClass: "input-error" }, [
                        _vm._v(_vm._s(_vm.errors.school_name.message)),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-wrapper" },
                [
                  _c("rt-input", {
                    attrs: {
                      placeholder: "Number of students",
                      floatingLabel: "Number of students",
                      type: "number",
                      borderError: _vm.errors.students.error,
                    },
                    model: {
                      value: _vm.form_data.students,
                      callback: function ($$v) {
                        _vm.$set(_vm.form_data, "students", $$v)
                      },
                      expression: "form_data.students",
                    },
                  }),
                  _vm._v(" "),
                  _vm.errors.students.error
                    ? _c("p", { staticClass: "input-error" }, [
                        _vm._v(_vm._s(_vm.errors.students.message)),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-wrapper" },
                [
                  _c("rt-input", {
                    attrs: {
                      placeholder: "Phone number (optional)",
                      floatingLabel: "Phone number (optional)",
                      type: "tel",
                      borderError: _vm.errors.phone.error,
                    },
                    model: {
                      value: _vm.form_data.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.form_data, "phone", $$v)
                      },
                      expression: "form_data.phone",
                    },
                  }),
                  _vm._v(" "),
                  _vm.errors.phone.error
                    ? _c("p", { staticClass: "input-error" }, [
                        _vm._v(_vm._s(_vm.errors.phone.message)),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-wrapper" },
                [
                  _c("rt-input", {
                    attrs: {
                      placeholder: "Email",
                      floatingLabel: "Email",
                      borderError: _vm.errors.email.error,
                    },
                    model: {
                      value: _vm.form_data.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.form_data, "email", $$v)
                      },
                      expression: "form_data.email",
                    },
                  }),
                  _vm._v(" "),
                  _vm.errors.email.error
                    ? _c("p", { staticClass: "input-error" }, [
                        _vm._v(_vm._s(_vm.errors.email.message)),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "button-wrapper" },
              [
                _c(
                  "primary-button",
                  {
                    staticClass: "btn-submit",
                    on: { click: _vm.handleClickSubmit },
                  },
                  [_vm._v("Submit")]
                ),
              ],
              1
            ),
          ])
        : _c("rt-picture", {
            staticClass: "icon-loading",
            attrs: {
              src: "/assets/app/class/icon-loading.svg",
              autosize: false,
            },
          }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title-wwrapper" }, [
      _c("h2", { staticClass: "form-title" }, [_vm._v("Request a quote")]),
      _vm._v(" "),
      _c("p", { staticClass: "form-description" }, [
        _vm._v("For a school/district plan"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }